export const ALLOWED_LANGUAGES = ['ko', 'en', 'ja', 'zh-cn', 'zh-tw'];
export const RELEASE_DATE_FOR_RECRUITMENT = new Date('2024-08-01T01:00:00Z');
export const MAMA_RELEASE_DATE = new Date('2024-11-22T10:30:00Z');
